<template>
    <div>
        <OprateDetail :paramsObj="currentDetailObj"></OprateDetail>
    </div>

</template>


<script>
    export default {
        created() {
            this.currentDetailObj = this.$route.query
            // this.$commonFunc.commonRequest('get', '/compute_header/list/condition', 'getOperateList', {leaseItemNumber: this.$route.query.leaseItemNum})
            //     .then(res=>{
            //         this.total = res.obj.total
            //         if(this.total == 0) {
            //             this.tableData = []
            //         } else {
            //             this.tableData = res.obj.list
            //             this.currentDetailObj = this.$route.query
            //             this.currentDetailObj.params = res.obj.list[0];
            //         }
            //     })
            //     .catch(res=>{
            //         this.$message.error(res.message)
            //     })
        },
        data () {
            return {
                //传递给详情组建的相关参数
                currentDetailObj: {
                    from: '',
                    fromPageName: '',
                    params: {},
                    uploadType: '',
                    leaseItemNumber: '',
                    headerId: '',
                    transactionType: '',
                    isShowPageType: 1
                }
            }
        },
        mounted () {

        }
    }

</script>



// WEBPACK FOOTER //
// src/pages/operate/OperateDetailsPage.vue